import { useAccountIdentity } from '@quality24/react-components';
import React from 'react';
import { Navigate, useLocation } from 'react-router';

import {
  InpatientIdentityAction,
  InpatientIdentityResource,
} from '@quality24/inpatient-typings';
import { useAccountInfo } from '@/inpatient-dashboard/hooks/auth/useAccountInfo';
import { useAuth } from '../hooks/auth/useAuth';

export interface Props {
  action?: InpatientIdentityAction;
  resources?: InpatientIdentityResource[];
  redirectTo?: string;
  children: JSX.Element;
}

/**
 * <PrivateRoute> component
 */
const PrivateRoute: React.FunctionComponent<Props> = ({
  action,
  resources,
  redirectTo = '/unauthorized',
  children,
}) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const { user, isUserProvisioned } = useAccountInfo();
  const { loading, hasPermission } = useAccountIdentity(user.id);

  // Return nothing until finish loading permissions
  if (loading) return null;

  if (!isAuthenticated || !isUserProvisioned) {
    return <Navigate to="/provision" state={{ from: location }} replace />;
  }

  // Test for the permission
  if (action && !hasPermission(action, resources)) {
    return <Navigate to={redirectTo} />;
  }

  return children;
};

export default PrivateRoute;
